'use client'

/**
 * Set (login) or clear (logout, `null`) the Snowplow user id, matching ui-react's
 * `SnowplowService.setUserId` / `removeUserId`. Silent no-op when the tracker is
 * not loaded — analytics must never break a page.
 */
export function setSnowplowUserId(userId: string | null): void {
    if (typeof window === 'undefined' || !window.snowplow) {
        return
    }
    window.snowplow('setUserId', userId)
}
